import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CalendarSelector = ({ calendars, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <FormControl fullWidth>
      <InputLabel>{t('calendar.calendar')}</InputLabel>
      <Select value={value || ''} label={t('calendar.calendar')} onChange={e => onChange(Number(e.target.value))}>
        {
          calendars.map(c => (
            <MenuItem key={c.kalenteriId} value={c.kalenteriId}>
              {c.nimi}
            </MenuItem>
          ))
        }
      </Select>
    </FormControl>
  );
};

export default CalendarSelector;
